import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { t } from '@lingui/core/macro';
import LocationFilterBase from '@duke-hq/filters/components/LocationFilterBase';
import type { LocationItem } from '@duke-hq/filters/types';

export default function ProviderLocationsFilters({
  onChange,
  providerId,
}: {
  onChange: (sites: string[], regions: string[]) => void;
  providerId: number;
}) {
  const { data: sites } = trpcAdmin.providers.locations.listSiteLocations.useQuery({
    providerId,
    filters: { available: true },
  });

  const { data: regions } = trpcAdmin.providers.locations.listSiteRegions.useQuery({
    providerId,
  });

  const locations: LocationItem[] = [
    ...(sites?.map((site) => ({
      id: site.id,
      name: site.name,
      state: site.state,
      type: 'site' as const,
    })) ?? []),
    ...(regions?.map((region) => ({
      id: region.id,
      name: region.name,
      state: '',
      type: 'region' as const,
    })) ?? []),
  ];

  const handleChange = (sites: string[], regions: string[]) => {
    onChange(sites, regions);
  };

  if (locations.length <= 1) {
    return null;
  }

  return (
    <LocationFilterBase
      locations={locations}
      onChange={handleChange}
      variant="outline"
      label={t`Location`}
      regionLabel={t`Region`}
      siteLabel={t`Site`}
    />
  );
}
